<template>
  <v-container fluid>
    <v-card outlined max-width="1000">
      <div class="mx-6 mt-4">
        <v-card-title>Add Variations</v-card-title>
        <v-text-field
          outlined
          v-model="variation"
          :loading="variation_loader"
        ></v-text-field>
        <v-btn @click="create_variation">Create variation</v-btn>
      </div>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */

export default {
  name: "variations-page",
  data() {
    return {
      variation: '',
      variation_loader: false,
    };
  },

  methods: {
    create_variation() {
      this.variation_loader = true;
      console.log('variation', this.variation)
      const payload = { task: "addVariation", payload: { variation: this.variation } };
      this.$store
        .dispatch("productionModule/general_api", payload)
        .then((res) => {
          console.log("variation respond", res.data);
        }).finally(() => {this.variation_loader = false})
    },
    // loadUsers() {
    //   // return
    //   if (this.users.length === 0) {
    //     const payload = { task: "getUsers" };
    //     this.$store
    //       .dispatch("productionModule/general_api", payload)
    //       .then((res) => {
    //         console.log("loadUsers", res.data);
    //         this.users = res.data.payload.users
    //       });
    //   }
    // },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/Variations.vue